export { default as translations } from './global.i18n.json';
export * from './translations-types';
